import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Box, Typography, Container } from '@mui/material';
import axios from 'axios';
import { handleError } from '../../services/ErrorHandler';

const ErrorTest = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState('');

  const testError404 = () => {
    navigate('/error/404');
  };

  const testError500 = () => {
    navigate('/error/500');
  };

  const testMaintenanceError = () => {
    navigate('/maintenance');
  };

  const testServerError = async () => {
    try {
      // This should cause a 500 error by calling a non-existent endpoint
      await axios.get('/api/test-error-endpoint');
    } catch (error) {
      setMessage('Error caught, handling with ErrorHandler');
      handleError(error, navigate);
    }
  };

  const testNetworkError = async () => {
    try {
      // This should cause a network error by calling a non-existent domain
      await axios.get('http://non-existent-domain-123456.com');
    } catch (error) {
      setMessage('Network error caught, handling with ErrorHandler');
      handleError(error, navigate);
    }
  };

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 5, mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          Error Page Test Tool
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Use these buttons to test different error scenarios and error page rendering.
        </Typography>
        {message && (
          <Typography variant="body1" sx={{ color: 'red', mb: 2 }}>
            {message}
          </Typography>
        )}
      </Box>
      
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={testError404}
        >
          Test 404 Error Page
        </Button>
        
        <Button 
          variant="contained" 
          color="error" 
          onClick={testError500}
        >
          Test 500 Error Page
        </Button>
        
        <Button 
          variant="contained" 
          color="warning" 
          onClick={testMaintenanceError}
        >
          Test Maintenance Error Page
        </Button>
        
        <Button 
          variant="contained" 
          color="secondary" 
          onClick={testServerError}
        >
          Test Real Server Error (API call)
        </Button>
        
        <Button 
          variant="contained" 
          color="info" 
          onClick={testNetworkError}
        >
          Test Network Error
        </Button>
      </Box>
    </Container>
  );
};

export default ErrorTest; 